import React, {Component} from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import _ from "lodash";
import {Alert, Input} from "reactstrap";
import PresentationTypeInput from "./components/PresentationTypeInput";
import PresentationTypeSlider from "./components/PresentationTypeSlider";
import PresentationTypeDragAndDrop from "./components/PresentationTypeDragAndDrop";
import InputGroupAddon from "reactstrap/es/InputGroupAddon";
import InputGroup from "reactstrap/es/InputGroup";
import classnames from "classnames";
import {getCurrentMicroTime} from "../../../../reducers/timeMeasuring/actions";
import {updateQuestionResponse} from "reducers/questionResponses/actions";
import CardContainer from "../Components/cardContainer";
import ImageOpenAnswer from "../Components/imageOpenAnswer";
import AnswerContainer from "../Components/answerContainer";

class NumericMulti extends Component {
  constructor(props){
    super(props);

    this.state = {
      answersWithErrors: [],
      errorForAnswer: []
    }

    this.onDetailChange = this.onDetailChange.bind(this);
    this.onOpenChange = this.onOpenChange.bind(this);
    this.presentationComponent = this.presentationComponent.bind(this);
    this.getSummaryValue = this.getSummaryValue.bind(this);
    this.getMinValueForAnswer = this.getMinValueForAnswer.bind(this);
    this.getMaxValueForAnswer= this.getMaxValueForAnswer.bind(this)
  }

  onOpenChange(answerId, content){
    const {question} = this.props;

    const microTime = getCurrentMicroTime(this.props.startTime);

    let exists = false;
    const details = this.props.details.map(detail => {
      if(detail.answer === answerId){
        detail.microTime = microTime;
        detail.content = content;
        exists = true;
      }

      return detail;
    });

    if(!exists){
      const detail = {
        answer: answerId,
        microTime,
        content,
        value1: question.valueMin,
        value2: null,
      }

      details.push(detail);
    }

    this.props.onDetailsUpdated(details);
  }

  onDetailChange(detail, answerId){
    let {details, question} = this.props;
    let exists = false;
    detail.value1 = Number(detail.value1)
    detail.value2 = Number(detail.value2)

    details = details.map(d => {
      if(d.answer === answerId){
        exists = true;
        return detail
      }

      return d;
    });

    if(!exists){
      details.push(detail);
    }

    this.props.onDetailsUpdated(details).then(() => {
      this.props.dispatch(updateQuestionResponse({
        ...this.props.questionResponse,
        valuesSum: _.sum(details.map(detail => detail.value1)),
      }));
    });
  }

  getMinValueForAnswer(answer){
    const {details, question} = this.props;
    if (question.presentationType !== 'psm') {
      return null;
    }

    let value = Math.round(this.props.question.valueMin);
    let maxValue = Math.round(this.props.question.valueMax);
    let isForceAddValue = this.props.question.incrementalStepPSM ? true : false;

    if(answer.position === 0){
      return value;
    }

    let position = answer.position-1;
    let currentAnswerPosition = answer.position;
    let detail = 0;
    while(position >= 0){
      let currentDetail = details.find(detail => {
        if(this.props.question.answers.find(a => a.id === detail.answer).position === position){
          return detail;
        }
      });

      if (currentDetail && currentDetail.value1 > detail) {
        let detailAnswer = this.props.question.answers.find((entry) => {
          return entry.id === currentDetail.answer;
        })
        detail = currentDetail.value1;
        if (isForceAddValue) {
          detail = detail + (currentAnswerPosition - detailAnswer.position)
        }

        if (detail > maxValue) {
          detail = maxValue;
        }
      }

      position--;
    }

    if(detail){
      return detail;
    }

    if (isForceAddValue) {
      return value + answer.position;
    }

    return value;
  }

  getMaxValueForAnswer(answer, detail) {
    const {details, question} = this.props;

    //ZABUGOWANA FUNCKJA USTAWIANIA MAX WARTOSCI W SUWAKU
    // if (question.summaryMax) {
    //   let sum = 0;
    //   details.map((det) => {
    //     sum = sum + det.value1
    //   })
    //
    //   let sumNoDetail = detail ? (sum - detail.value1) : 0;
    //   if (sum >= question.summaryMax && detail) {
    //     return question.summaryMax - sumNoDetail
    //   }
    // }

    return null;
  }

  presentationComponent(answer, detail){
    const {question, validate, surveyNav, details, questionResponse} = this.props;
    const {answersWithErrors} = this.state;

    const defaultProps = {
      answer: answer,
      detail: detail,
      details: details,
      validate: validate,
      question,
      onBlur: this.onBlur,
      isError: !surveyNav.hideValidation && answersWithErrors.includes(answer.id),
      forceMinValue: this.getMinValueForAnswer(answer),
      forceMaxValue: this.getMaxValueForAnswer(answer, detail),
      onOpenChange: e => this.onOpenChange(answer.id, e.target.value),
      onDetailUpdated: (detail) => this.onDetailChange(detail, answer.id),
      questionResponse: questionResponse
    };

    switch (question.presentationType) {
      case 'input':
        return <PresentationTypeInput {...defaultProps}/>;
      case 'slider':
        return <PresentationTypeSlider {...defaultProps}/>;
      case 'psm':
        if (question.psmType === 'input') {
          return <PresentationTypeInput {...defaultProps}/>;
        } else {
          return <PresentationTypeSlider {...defaultProps}/>;
        }
      default:
        return <p>{question.presentationType}</p>;
    }
  }

  getSummaryValue(){
    const {details, question} = this.props;

    const sum = _.sum(details.map(detail => detail.value1));

    if (sum && question.decimals && sum > 0) {
      return sum.toFixed(question.decimals) / Math.pow(10, question.decimals);
    }

    return sum;
  }

  validate(){
    const {question, validationTexts, details} = this.props;
    const {answers} = this.props.question;

    let validate = {
      valid: true,
      errors: []
    };

    let answersWithErrors = [];
    if(question.required){
      const noResponseAnswers = question.answers.filter(answer => {
        if(answer.excludeRequired){
          return false;
        }

        if(details.filter(detail => detail.answer === answer.id).length === 0){
          return true;
        }

        return false;
      });

      if(noResponseAnswers.length > 0){
        answersWithErrors = noResponseAnswers.map(answer => answer.id)
        validate.errors.push(validationTexts.required);
      }
    }

    if(question.summaryMin > 0 && !question.range){
      if(this.getSummaryValue() < question.summaryMin){
        validate.errors.push(validationTexts.summaryMin);
      }
    }

    if(question.summaryMax > 0 && !question.range){
      if(this.getSummaryValue() > question.summaryMax){
        validate.errors.push(validationTexts.summaryMax);
      }
    }

    if (!_.isEmpty(details)) {
      _.each(details, detail => {
        const answer = answers.find(ans => ans.id === parseInt(detail.answer));
        const content = detail.content;

        if (answer.isOpen && _.isEmpty(content) && !answer.openIsNotRequired) {
          if (validate.errors.indexOf(validationTexts.detail.answerContentEmpty) === -1){
            validate.errors.push(validationTexts.detail.answerContentEmpty);
          }
        }
      });
    }

    this.setState({
      answersWithErrors
    })

    validate.valid = _.isEmpty(validate.errors)
    return validate;
  }

  render() {
    const {question, details, surveyNav, questionResponse} = this.props;
    const {answersWithErrors} = this.state;

    if(question.presentationType === 'dragAndDrop'){
      return <PresentationTypeDragAndDrop
        onDetailChange={this.onDetailChange}
        question={question}
        details={details}
      />
    }

    const summaryValue = this.getSummaryValue();
    const answersColumnClass = 'col-md-' + question.divisionColumn;
    const inputsColumnClass = 'col-md-' + (12 - question.divisionColumn);

    return <div className={"p-0 m-0 cards-container row"}>
      {question.answers.map((answer, key) => {
        const detail = details.find(d => d.answer === answer.id) || {
          answer: answer.id,
          value1: null,
          value2: null,
        };
        let style = {};
        if (!!question.sliderVertical) {
          style['height'] = '350px';
        }

        return <div className={question.answersColumns > 1 ? "pr-lg-2 pl-lg-2 col-lg-"+parseInt(12 / question.answersColumns) : "p-0 col-sm-12"}>
          <CardContainer
            classes={classnames({
              "col-sm-12": true,
              'error': !surveyNav.hideValidation && answersWithErrors.includes(answer.id) && !questionResponse.excluding
            })}
            component={this.presentationComponent(answer, detail)}
          />
        </div>
      })}
      {!question.range && question.summaryVisibility && <AnswerContainer
            classes={"text-center pointer-none font-weight-bold p-0 numeric-multi-counter"}
            checked={false}
            component={
              <div className={"d-flex align-items-center h-100"}>
                <span className={"w-100"}>
                  RAZEM: {summaryValue} {question.valueText ? question.valueText : ""}
                </span>
              </div>
            }
      />}
    </div>
  }
}

NumericMulti.propTypes = {
  questionResponse: PropTypes.object.isRequired,
  question: PropTypes.shape({
    answers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      content: PropTypes.string.isRequired,
      isOpen: PropTypes.bool.isRequired,
    }),).isRequired,
    required: PropTypes.bool.isRequired,
    presentationType: PropTypes.oneOf(['input', 'slider', 'dragAndDrop', 'psm']).isRequired,
    answersImage: PropTypes.bool.isRequired,
    summaryMin: PropTypes.number.isRequired,
    summaryMax: PropTypes.number.isRequired,
    divisionColumn: PropTypes.number.isRequired,
    summaryVisibility: PropTypes.bool.isRequired,
    valueText: PropTypes.string,
    answersColumns: PropTypes.number,
  }).isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    answer: PropTypes.number.isRequired,
    value1: PropTypes.number.isRequired,
    value2: PropTypes.number,
    microTime: PropTypes.number.isRequired,
  }).isRequired),
  id: PropTypes.number.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
  validationTexts: PropTypes.shape({
    required: PropTypes.string,
    summaryMax: PropTypes.string,
    summaryMin: PropTypes.string,
  }),
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
    surveyNav: state.surveyNav
  }
}, null, null, {withRef: true, forwardRef: true})(NumericMulti);